module.exports = __webpack_public_path__ + "media/images/bigshort-9a158a1b9a36efef82b82a1d763079ae.jpeg";